module.exports = __webpack_public_path__ + "img/MGH-Gaien-9.6e94d5b1.jpg";